import template from "./quote-template-edit-name-modal.html";

const QuoteTemplateEditNameModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class QuoteTemplateEditNameModalController {
    /* @ngInject */
    constructor($rootScope, $state) {
      this.$rootScope = $rootScope;
      this.$state = $state;
    }

    async $onInit() {
      this.quoteTemplateName = this.resolve.quoteTemplateName;
    }

    returnQuoteTemplateName(quoteTemplateName) {
      this.close({ $value: quoteTemplateName });
    }

    close() {
      this.dismiss({ $value: "cancel" });
    }
  },
};

export default QuoteTemplateEditNameModalComponent;
